const state = {
  sops: [],
  sop: {},
};

export default state;
